module.exports = __webpack_public_path__ + "img/arrow.db355674.svg";